<script lang="ts">
    import { onMount } from "svelte";
    import { navigate } from "svelte-navigator";
    import type {
        LocationListEntry,
        NetworkResponse,
    } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { locationStore } from "../../../../../store/locations";
    import { user } from "../../../../../store/stores";
    import Locations from "../../../_Home/_Statistics/Locations.svelte";
    import TableRow from "./NetworkLocationTableRow.svelte";
    import TableHead from "./NetworkTableHead.svelte";

    export let network: NetworkResponse;
    let showLocationEdit = false;
    let locationEditObject: LocationListEntry;
    let fetching: boolean = false;
    let status: boolean | null = null;
    let errorMessage: string = "Die Erstellung ist fehlgeschlagen.";

    const updateLocation = async () => {
        if (locationEditObject && locationEditObject.id !== "") {
            await $user.updateToken().then(async () => {
                ApiClient.getInstance()
                    .locationClient.updateLocation({
                        locationId: locationEditObject.id,
                        locationRequest: {
                            ...locationEditObject,
                        },
                    })
                    .then((result) => {
                        fetching = false;
                        status = true;
                        locationStore.update((locationStore) => {
                            return {
                                ...locationStore,
                                locations: {
                                    ...Locations,
                                    entries: [
                                        ...locationStore.locations.entries.map(
                                            (entry) => {
                                                if (
                                                    entry.id ===
                                                    locationEditObject.id
                                                ) {
                                                    return locationEditObject;
                                                }
                                                return entry;
                                            }
                                        ),
                                    ],
                                },
                            };
                        });
                    })
                    .catch((error) => {
                        fetching = false;
                        status = false;
                        errorMessage = error;
                    });
            });
        }
    };

    const deleteLocation = async (locationId) => {
        await $user.updateToken().then(async () => {
            ApiClient.getInstance()
                .locationClient.deleteLocation({
                    locationId: locationId,
                })
                .then(() => getLocationsForNetwork())
                .catch(() => alert("Da ist etwas schief gelaufen."));
        });
    };

    const getLocationsForNetwork = async () => {
        locationStore.update((locationStore) => {
            return {
                ...locationStore,
                locations: {
                    entries: [],
                },
            };
        });
        const recursiveFetch = async (page: number) => {
            await ApiClient.getInstance($user)
                .locationClient.listLocations({
                    size: 100,
                    page,
                    network: network.id,
                })
                .then((locations) => {
                    console.log(locations, "response");
                    locationStore.update((locationStore) => {
                        return {
                            ...locationStore,
                            locations: {
                                ...locations,
                                entries: [
                                    ...locationStore.locations.entries,
                                    ...locations.entries,
                                ],
                            },
                        };
                    });
                    if (!locations.hasNext) return;
                    recursiveFetch(locations.page + 1);
                });
        };
        await recursiveFetch(0);
    };

    onMount(() => getLocationsForNetwork());
    console.log($locationStore);
</script>

<div>
    {#if showLocationEdit && locationEditObject}
        <div class="columns is-centered">
            <div class="column is-half">
                <div style="padding: 2rem">
                    {#if status}
                        <div class="notification is-success">
                            <button
                                class="delete"
                                on:click={() => (status = null)}
                            />
                            <p>
                                Die Location mit der ID <b
                                    >{locationEditObject.id}</b
                                > wurde gespeichert.
                            </p>
                        </div>
                    {:else if status === false}
                        <div
                            class="notification is-danger"
                            on:click={() => (status = null)}
                        >
                            <button class="delete" />
                            <p>{errorMessage}</p>
                        </div>
                    {/if}

                    <div class="field">
                        <label for="locationId" class="label field-name"
                            >Name</label
                        >
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Location ID"
                                name="name"
                                bind:value={locationEditObject.name}
                            />
                        </div>
                    </div>
                    <div class="field">
                        <label for="addressLine1" class="label field-name"
                            >Adresse</label
                        >
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Adresse"
                                name="addressLine1"
                                bind:value={locationEditObject.address
                                    .addressLine1}
                            />
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <input
                                class="input"
                                type="text"
                                placeholder="Adresse - 2. Zeile"
                                name="addressLine2"
                                bind:value={locationEditObject.address
                                    .addressLine2}
                            />
                        </div>
                    </div>
                    <div class="field-body field-margin">
                        <div class="field">
                            <div class="control">
                                <input
                                    class="input"
                                    type="text"
                                    placeholder="Postleitzahl"
                                    name="postalCode"
                                    bind:value={locationEditObject.address
                                        .postalCode}
                                />
                            </div>
                        </div>
                        <div class="field">
                            <div class="control">
                                <input
                                    class="input"
                                    type="text"
                                    placeholder="Stadt"
                                    name="city"
                                    bind:value={locationEditObject.address.city}
                                />
                            </div>
                        </div>
                    </div>
                    <div class="field ">
                        <!-- svelte-ignore a11y-label-has-associated-control -->
                        <label class="label">Status</label>
                        <div class="control">
                            <div class="select">
                                <select bind:value={locationEditObject.active}>
                                    <option value={true}>aktiv</option>
                                    <option value={false}>deaktiviert</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div
                        class="field is-grouped is-flex is-justify-content-space-between"
                    >
                        <div class="control">
                            <button on:click={() => updateLocation()}>
                                Speichern
                            </button>
                        </div>
                        <div class="control">
                            <button
                                on:click={() =>
                                    deleteLocation(locationEditObject.id)}
                            >
                                Löschen
                            </button>
                        </div>
                        <div class="control">
                            <button
                                class="button is-link is-light"
                                on:click={() => {
                                    showLocationEdit = false;
                                    locationEditObject = undefined;
                                }}
                            >
                                Zurück
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:else}
        <table class="table full-width">
            <TableHead />
            <tbody>
                {#if $locationStore?.locations?.entries}
                    {#each $locationStore.locations.entries as location}
                        <TableRow
                            {location}
                            selectCallback={() => {
                                showLocationEdit = true;
                                locationEditObject = location;
                            }}
                        />
                    {/each}
                {/if}
            </tbody>
        </table>
    {/if}
</div>

<style>
    .full-width {
        width: 100%;
        position: relative;
    }
</style>
